export default __webpack_public_path__ + "static/img/app_store.8b16922.svg";